import { autoPlacement, autoUpdate, offset, useFloating } from '@floating-ui/react-dom';

import { FLOATING_PLACEMENT } from 'src/data/ui';

import { DEFAULT_TOOLTIP_MARGIN } from '../../const';
import { expandPadding } from '../../utils';

export const useTooltipFloating = ({ referenceElement, floatingElement, options }) => {
  return useFloating({
    elements: {
      reference: referenceElement,
      floating: floatingElement,
    },
    placement: options.placement,
    middleware: [
      offset(
        ({ placement }) => ({
          mainAxis: getTooltipDistance(options, placement),
          crossAxis: getTooltipSkidding(options, placement),
        }),
        options
      ),
      ...(options.placement === FLOATING_PLACEMENT.auto ? [autoPlacement()] : []),
    ],
    whileElementsMounted: autoUpdate,
  });
};

const getTooltipSkidding = (options, placement) => {
  const paddings = getExpandedPaddings(options);
  if (placement.endsWith('start')) {
    return -1 * paddings.left;
  }
  if (placement.endsWith('end')) {
    return paddings.right;
  }
  return 0;
};

const getTooltipDistance = (options, placement) => {
  const paddings = getExpandedPaddings(options);
  const margin = options?.tooltipMargin || DEFAULT_TOOLTIP_MARGIN;
  if (placement.startsWith('top')) {
    return paddings.top + margin;
  }
  if (placement.startsWith('bottom')) {
    return paddings.bottom + margin;
  }
  if (placement.startsWith('left')) {
    return paddings.left + margin;
  }
  return paddings.right + margin;
};

const getExpandedPaddings = (options) => {
  const mainSpotlight = options?.spotlights?.[0];
  return expandPadding(mainSpotlight?.padding);
};
